module.exports = __webpack_public_path__ + "10164f6d41e999d9bff511d1fad2828d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-0.png
// module id = 2374
// module chunks = 0